import PropTypes from "prop-types";
import React from "react";
import { Status as StatusUI } from "@weezevent/nacre";
import { useTranslation } from "react-i18next";

const Status = ({ removed, ...rest }) => {
	const { t } = useTranslation();

	const isActive = removed === null;
	const statusColor = isActive ? "green" : "red";
	const statusText = isActive
		? t("access.attendees.attendeesList.activeAttendee")
		: t("access.attendees.attendeesList.deletedAttendee");

	return <StatusUI color={statusColor} text={statusText} {...rest} />;
};

Status.propTypes = {
	removed: PropTypes.oneOfType([
		PropTypes.instanceOf(Date),
		PropTypes.string,
		PropTypes.oneOf([null])
	])
};

Status.defaultProps = {
	removed: null
};

export default React.memo(Status);
